import Vue from 'vue'

export default {
  setUsers(state, users) {
    state.all = users
  },
  newUser(state, user) {
    state.all.push(user)
    Vue.set(state, 'all', [...state.all])
  },
  deleteUser(state, user) {
    const userIndex = state.all.findIndex(usr => usr.id === user.id)
    if (userIndex >= 0) {
      state.all.splice(userIndex, 1)
      Vue.set(state, 'all', [...state.all])
    }
  },
  removeUser(state, user) {
    const users = state.all
    const ids = users.map(user => user.id)
    const index = ids.indexOf(user.id)
    users.splice(index, 1)
    Vue.set(state, "all", [...users])
  },
  requestingUsers(state) {
    state.loading = true
  },
  receivedUsers(state) {
    state.loading = false
  },
  clearUser(state) {
    state.currentlySelected = {
      user: {},
      loading: true
    }
  },
  setUser(state, user) {
    state.current.user = user
  },
  setPreferences(state, prefs) {
    state.current.preferences = prefs
  },
  setUserTeams(state, teams) {
    state.current.teams = teams
  },
  setUserAvatarUrl(state, url) {
    state.current.user.avatar_url = url
  },
  setUserAuthToken(state, { user, authToken }) {
    if (state.currentlySelected.user.id === user.id) {
      state.currentlySelected.user.authenticationToken = authToken
    }
  },
  updatePassword(state, data) {
    state.currentlySelected.user.password = data.password
    state.currentlySelected.user.password_confirmation = data.confirmation
  },
  addTeamToSelectedUser(state, team) {
    state.currentlySelected.user.teams.push(team)
  },
  removeTeamFromSelectedUser(state, team) {
    const index = state.currentlySelected.user.teams.indexOf(team)
    state.currentlySelected.user.teams.splice(index, 1)
  },
  setCurrentlySelectedUser(state, data) {
    state.currentlySelected.user = data
  },
  setCurrentlySelectedLoading(state, data) {
    state.currentlySelected.loading = data
  },
  createTeamMembership(state, { allTeams, teamId, userId }) {
    if (state.currentlySelected && state.currentlySelected.user && state.currentlySelected.user.id === userId) {
      const team = allTeams.find(team => team.id === teamId)
      state.currentlySelected.user.teams.push(team)
      Vue.set(state.currentlySelected.user, 'teams', [...state.currentlySelected.user.teams])
    }
  },
  deleteTeamMembership(state, { teamId, userId }) {
    if (state.currentlySelected && state.currentlySelected.user && state.currentlySelected.user.id === userId) {
      const userTeams = state.currentlySelected.user.teams
      const teamIndex = userTeams.findIndex(team => team.id === teamId)
      if (teamIndex >= 0) {
        userTeams.splice(teamIndex, 1)
        Vue.set(state.currentlySelected.user, 'teams', [...userTeams])
      }
    }
  }

}
